<template>
  <div class="contain-box">
    <el-row
      type="flex"
      justify="center"
      class="wrap-row"
    >
      <el-col class="wrap-col" :xs="24" :sm="24" :md="14" :lg="14"   :xl="14">
          <div class="desc-tips" shadow="hover">
            <div v-html="$t('guestID.bgDesc')"></div>
            <span v-html="$t('guestID.verifyDesc')"></span>
          </div>
          <div class="tab-list">
            <span @click="tabHandleClick(item)" :class="{'active': currentOrderInfo.value === item.value}" v-for="item in list" :key="item.value">{{listStr[item.type]}}</span>
          </div>

          <div class="tab-content">
            <h6 v-if="currentOrderInfo.type == 'CONFIRM_NO'">{{$t('guestID.verifyOrder.tip')}}</h6>
            <h6 v-else-if="currentOrderInfo.type == 'PHONE'">{{$t('guestID.verifyPhone.tip')}}</h6>
            <h6 v-else>{{$t('guestID.verifyEmail.tip')}}</h6>
            <div class="order">
              <span>{{currentOrderInfo.value}}</span>
              <el-input :placeholder="$t('guestID.verifyLast4chars')" style="width:190px;margin-left: 5px;" v-model="value">
                <el-button  slot="append" icon="el-icon-check" @click="verify()"></el-button>
              </el-input>
            </div>
          </div>
        <component
          v-if="false"
          :is="config.step.cmp"
          :referenceUrl='config.referenceUrl'
          :openOrderId='openOrderId'
          @show-big-img="showBigImg"
          @verifySuccess="verifySuccess"
          @upload-success="uploadSuccess"
        ></component>
      </el-col>
    </el-row>
    <el-dialog
      :visible.sync="config.bigImgDialogVisible"
      :show-close="true"
      :title="$t('guestID.refImgDesc')"
      top="20px"
      width="90%"
      append-to-body
      modal-append-to-body
    >
      <img
        width="100%"
        style="max-width: 500px; display: block; margin: 0px auto;"
        :src="config.bigImgDialogUrl"
      >
    </el-dialog>

    <el-dialog
      :visible.sync="config.contactUsVisible"
      :title="$t('guestID.contactUs')"
      :show-close="true"
      top="20px"
      width="90%"
      append-to-body
      modal-append-to-body
    >
      <div
        style="word-wrap:break-word; line-height: 28px;"
        v-html="$t('guestID.concatWay')"
      ></div>
    </el-dialog>
  </div>
</template>

<script>
import Verify from '@/components/identification/Verify.vue'
import Upload from '@/components/identification/Upload.vue'
import UnknownOrder from '@/components/identification/UnknowOrder.vue'
import { methodList, authenticate } from '@/api/identification'
const i18n = 'guestID.'

export default {
  name: 'Identification',
  components: { UnknownOrder, Verify, Upload },
  data () {
    return {
      openOrderId: null,
      config: {
        step: null,
        referenceUrl: 'https://ostay-open-img.oss-ap-northeast-1.aliyuncs.com/resources/img/open/reference/passport.jpg',
        bigImgDialogUrl: null,
        contactUsVisible: false,
        bigImgDialogVisible: false,
      },
      list: [],
      currentOrderInfo: {},
      value: null,
    }
  },
  computed: {
    listStr () {
      return {
        CONFIRM_NO: this.$t(`${i18n}verifyOrder.header`),
        PHONE: this.$t(`${i18n}verifyPhone.header`),
        EMAIL: this.$t(`${i18n}verifyEmail.header`),
      }
    },
  },
  methods: {
    init () {
      this.openOrderId = this.$route.params.openOrderId
      this.getMethodList()
    },
    async getMethodList () {
      const res = await methodList({ openId: this.openOrderId })
      if (res.errMsg === 'success') {
        this.list = res.data.datas
        this.currentOrderInfo = res.data.datas[0]
      }
      console.log(res)
    },
    tabHandleClick (item) {
      this.currentOrderInfo = item
      this.value = null
    },
    verify () {
      console.log(this.currentOrderInfo)
      // var authInfo = this.$route.params.openOrderId
      if (this.value === null) {
        this.$message.warning('Please enter at least one validation item')
        return
      }
      authenticate({
        openId: this.openOrderId, type: this.currentOrderInfo.type, value: this.currentOrderInfo.value.replace('****', this.value),
      }).then(res => {
        if (res.errCode === '200') {
          console.log(this.$route)
          this.$cookie.setCustomerInfo(res.data || {})
          this.$router.push({ path: `/identification-agreement/${this.openOrderId}` })
        } else {
          this.$message.error(res.errMsg)
        }
      }).catch(() => {})
    },
  },
  created () {
    var authInfo = this.$cookie.getCustomerInfo()
    if (authInfo && authInfo.openId === this.$route.params.openOrderId) {
      this.$router.push({ path: `/identification-agreement/${authInfo.openId}` })
      return
    }
    this.init()
  },
}
</script>

<style lang="scss" scoped>
.contain-box {
  position: relative;
  // padding: 0 20px;
  box-sizing: border-box;
  .wrap-row {
    height: 100%;
    // padding: 0 20px;
    // .wrap-col {
    //   display: flex;
    //   margin: 0px auto;
    //   justify-content: center;
    // }
  }
  .desc-tips {
    // margin: 10px 0px 30px 0px;
    padding: 0px 5px 0px 5px;
    color: #606266;
    font-size: medium;
    line-height: 22px;
    font-size: 14px;
    white-space: normal;
    color: #B59429;
    font-weight: bold;
    background-color: #F5F7fA;
    padding: 0 20px;
    span {
      color: #FF0000;
      font-weight: 400;
    }
  }
  .tab-content {
    // margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    h6 {
      text-align: center;
      font-size: 16px;
      font-weight: 400;
      color: #85878B;
      margin-top: 24px;
      margin-bottom: 10px;
      padding: 0;

    }
  }
  .tab-list {
    display: flex;
    flex-direction: row;
    color: #ABADB2;
    gap: 30px;
    position: relative;
    background-color: #F5F7fA;
    padding: 0 20px;
    padding-bottom: 20px;
    padding-top: 20px;
    .active::after {
      content: '';
      position: absolute;
      width: 48px;
      border-bottom: 2px solid #B59429;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      bottom: -8px;
    }
    .active {
      color: #22252B;
      position: relative;

    }
  }
}
.el-steps--horizontal {
  /deep/.el-step__title {
    font-size: 14px !important;
  }
}
/deep/.el-dialog__body {
  padding: 0px 20px 30px;
}
</style>
